import React from "react";
import { Link } from "react-router-dom";

const WaitlistSection = () => {
  return (
    <section id="waitlist" className="waitlist-section">
      <div className="container waitlist-inner">
        <h2 className="waitlist-title">Ready to join the private beta?</h2>
        <p className="waitlist-subtitle">
          Share your sequencing goals and we will follow up with access details.
        </p>
        <div className="waitlist-actions">
          <Link to="/waitlist" className="waitlist-btn">
            Join Waitlist
          </Link>
        </div>
      </div>
    </section>
  );
};

export default WaitlistSection;
